module.exports = __webpack_public_path__ + "static/media/hotsite-area-reservada.16e39e6f.png";